import styled from '@emotion/styled';
import {
  BREAKPOINT_SMALL,
  MarketingHeading1,
} from '../../../../components/MarketingPagesShared/styles';

const Section = styled.section`
  color: #fff;
  text-align: center;
  padding: 80px 24px 0;
  background-size: cover;
  @media (max-width: 768px) {
    padding: 56px 16px 40px 16px;
    background-image: none;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1068px;
  width: 100%;
  margin: auto;
`;

const Heading = styled(MarketingHeading1)`
  text-align: center;
  max-width: 880px;
  width: 100%;
  margin: auto;
`;

const SubHeader = styled.h2`
  font-size: 1.4rem;
  line-height: 2rem;
  text-align: center;
  color: #ffffff;
  opacity: 0.85;
  max-width: 256px;
  width: 100%;
  margin: auto;
`;

const HeroImageContainer = styled.div`
  margin: 92px 0 164px;
  img {
    width: 100%;
  }
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin-bottom: 80px;
  }
`;

const HeroImageMobileWrapper = styled.div`
  display: none;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    display: block;
  }
`;

const HeroImageDesktopWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(6, 1fr);
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    display: none;
  }
`;

const HeroImageDesktopPictureWrapper1 = styled.div`
  grid-column: 2 / 13;
  grid-row: 1 / 7;
`;

const HeroImageDesktopPictureWrapper2 = styled.div`
  grid-column-start: 1;
  grid-column-end: 6;
  grid-row: 3 / 7;
`;

export {
  Section,
  ContentWrapper,
  Heading,
  SubHeader,
  HeroImageContainer,
  HeroImageMobileWrapper,
  HeroImageDesktopWrapper,
  HeroImageDesktopPictureWrapper1,
  HeroImageDesktopPictureWrapper2,
};
